module.exports = __webpack_public_path__ + "static/FireBaseProjectID-7d6fc29883b3eef1ea12a174a5701e27.png";